export const RED = '#FF3766';
export const YELLOW = '#eab308';
export const GREEN = '#3BE98B';

export const ADJ_R2_GRADIENT = `linear-gradient(to right, ${RED}, ${YELLOW} 40%, ${GREEN} 75%)`;
export const DURBIN_WATSON_GRADIENT = `linear-gradient(to right, ${RED}, ${GREEN} 50%, ${RED})`;
